exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".chart-options[data-v-582e71e8]{padding:20px 30px;text-align:center}.chart-options label[data-v-582e71e8]{margin-right:20px;cursor:pointer}.chart-options label input[type=checkbox][data-v-582e71e8]{margin-right:5px}.chart-options label span[data-v-582e71e8]{padding-right:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-582e71e8&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/DynamicChartComponent.vue
// module id = 825
// module chunks = 2